import {useEffect} from 'react';

/**
 * Close a menu/dropdown when clicking outside of specified refs.
 * @param {boolean} active - whether the listener is active (e.g. menuOpen)
 * @param {Function} onClose - called when an outside click is detected
 * @param  {...React.RefObject} refs - refs to elements considered "inside"
 */
export default function useClickOutside(active, onClose, ...refs) {
    useEffect(() => {
        if (!active) return;
        function handleMouseDown(e) {
            const isInside = refs.some(ref => ref.current && ref.current.contains(e.target));
            if (!isInside) onClose();
        }
        document.addEventListener('mousedown', handleMouseDown);
        return () => document.removeEventListener('mousedown', handleMouseDown);
    }, [active, onClose, refs]);
}
